import { GATrackingEvent } from '../ga-tracking-event.model';
import { GATrackingEventPayload } from '../ga-tracking-event-payload.model';
import {GaTrackingEventName, GATrackingEventType} from '../../constants';

import {PageNameTypes} from '~shared/modules/application-event/constants';

export class GATrackingAlternativeProductsShowEvent implements GATrackingEvent {

  constructor(private pageType: PageNameTypes) {}

  getEventType(): GATrackingEventType {
    return GATrackingEventType.AlternativeProductsShow;
  }

  getPayload(): GATrackingEventPayload {
    return {
      event: GaTrackingEventName.AlternativeProducts,
      label: `${this.pageType}`
    };
  }
}
